export enum ActionTypes {
  REQUEST = "@ano-letivo/REQUEST",
  SUCCESS = "@ano-letivo/SUCCESS",
  FAILURE = "@ano-letivo/FAILURE",
  CLEAN = "@ano-letivo/CLEAN",
}

export interface IState {
  loading: boolean;
  error: boolean;
  anoLetivo: number;
}
